import React from 'react';
import {FormattedMessage} from 'react-intl';
import Search, {SearchInputType} from "@components/custom/Search";
import {VideoFileStatusOptions} from "@models/video-file";


interface SearchInputProps {
  search: (filter: object) => any;
  form: any;
}

const SearchVideoFilesComponent: React.FC<SearchInputProps> = props => {
  const {search} = props;

  const inputs = [{
    name : "query",
    label : <FormattedMessage id="app.title" defaultMessage={`Title`}/>,
    type : SearchInputType.TEXT,
    size : 12
  },{
    name: "status",
    label: <FormattedMessage id="app.status" defaultMessage={`Status`}/>,
    type: SearchInputType.SELECT,
    options: VideoFileStatusOptions,
    size: 12
  }];
  
  return <Search inputs={inputs} search={search}/>
  
};

export default SearchVideoFilesComponent;